function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.334 2.667H2.667c-.737 0-1.333.597-1.333 1.333v8c0 .736.596 1.333 1.333 1.333h10.666c.737 0 1.334-.597 1.334-1.333V4c0-.736-.597-1.333-1.333-1.333zm0 9.333H2.667V5.333h10.667V12zM7 10.667H4.333A.333.333 0 014 10.333V7c0-.184.15-.333.333-.333H7c.184 0 .333.149.333.333v3.333c0 .184-.149.334-.333.334zM9 8h2.667c.184 0 .333-.15.333-.333V7a.333.333 0 00-.333-.333H9A.333.333 0 008.667 7v.667c0 .184.15.333.333.333zm1.334 2.667H9a.333.333 0 01-.333-.334v-.666c0-.184.15-.334.333-.334h1.334c.184 0 .333.15.333.334v.666c0 .184-.15.334-.333.334z"
});

var SvgBio = function SvgBio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgBio;